import { APIService } from './api.service';

export class ContactListService extends APIService {
  constructor() {
    super();
  }

  public async create(data: any): Promise<any> {
    return await this._post(`/fauna/business/contact-list`, data);
  }

  public async update(data: any, listId: string): Promise<any> {
    return await this._patch(`/fauna/business/contact-list/${listId}`, data);
  }

  public async delete(data: any, listId: string): Promise<any> {
    return await this._put(`/fauna/business/contact-list/${listId}`, data);
  }
}
